import * as React from "react";
import {IReadNewsResponse} from "../../core/api/post/response/ReadNewsResponse";

interface IProps {
    data: IReadNewsResponse[] | undefined;
}

interface IState {
    item: {}
}

export class HomeNews extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            item: {}
        }
    }

    public render() {
        return (
            <section className="small-section bg-gray-lighter">
                <div className="container relative">
                    <h2 className="section-title font-alt align-left mb-70 mb-sm-40">Berita Terbaru
                        <a className="section-more right" href="/berita">Lihat semua berita </a>
                    </h2>

                    {this.props.data === undefined || (this.props.data !== undefined && this.props.data.length < 1) ? <p>Tidak ada berita terbaru.</p> : (
                        <div className="row multi-columns-row">
                            {this.props.data !== undefined && this.props.data.map((value) => (
                                <div
                                    className="col-sm-6 col-md-4 col-lg-4 mb-md-50 wow fadeIn"
                                    data-wow-delay="0.1s"
                                    data-wow-duration="2s">
                                    <div className="post-prev-img">
                                        <a href={'/berita/' + value.id}>
                                            <img src={value.image} alt="image" />
                                        </a>
                                    </div>
                                    <div className="post-prev-title font-alt">
                                        <a href={'/berita/' + value.id}>{value.title}</a>
                                    </div>
                                    <div className="post-prev-text">
                                        <p>{value.shortDescription}</p>
                                    </div>
                                </div>
                            ))}

                        </div>
                    )}

                </div>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/home/HomeNews.tsx